import React, { Component } from "react";
import { Spin, Modal } from "antd";
import moment from "moment";
import { showErrorNotification, strings, perPage } from "../../helpers";
import { getSavedNewsArticlesList } from "../../services";
import NewsInterestsView from "./NewsInterestsView";

export default class NewsInterestsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      newsArticleList: [],
      newsType: "PHARMA"
    };
  }

  componentDidMount() {
    this.handleFetchNewsInterests();
  }

  /**
   * @function getArticlesList
   * @description it will show news article list
   */
  handleFetchNewsInterests = () => {
    const { pageNo, newsType } = this.state;
    this.setState({
      isProcessing: true
    });
    getSavedNewsArticlesList(newsType, pageNo, perPage)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { interests } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            newsArticleList: interests,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            newsArticleList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ newsArticleList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @param page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, newsArticleList: [] }, () => {
      this.handleFetchNewsInterests();
    });
  };

  /**
   * @function handleFilterNewsType
   * @param filterType
   * @description This function handles filtering interest types
   */
  handleFilterNewsType = filterType => {
    this.setState({ newsType: filterType, pageNo: 1 }, () =>
      this.handleFetchNewsInterests()
    );
  };

  render() {
    const { isProcessing, newsArticleList, totalRecords, pageNo } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <NewsInterestsView
          newsArticleList={newsArticleList}
          totalRecords={totalRecords}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          handleFilterNewsType={this.handleFilterNewsType}
        />
      </Spin>
    );
  }
}
